import { render, staticRenderFns } from "./overall-rating.vue?vue&type=template&id=1fa12f87&scoped=true&"
import script from "./overall-rating.vue?vue&type=script&setup=true&lang=js&"
export * from "./overall-rating.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./overall-rating.vue?vue&type=style&index=0&id=1fa12f87&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fa12f87",
  null
  
)

export default component.exports